export { default } from './use-delete-activity'
